export const VARIANT_ALLOC_CONTROLS = `variantAllocControls`;

export const UN_MITIGATED_VARIANT = `Initial`;
